import React from 'react';
import SiteCategoriesFilter from './filters/SiteCategoriesFilter';

export default function SiteSearchFilters() {
  return (
    <>
      <SiteCategoriesFilter />
    </>
  );
}
